import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { NotificationContainer } from 'react-notifications';
import { NotificationManager as N } from 'react-notifications';
import { useHistory } from 'react-router-dom';

import api from '../../../../services/api';
import MediaManagerContext from '../../MediaManagerContext';

import ButtonLoader from '../../../../components/ButtonLoader';
import RatingView from '../../../../components/RatingView';

import 'react-notifications/lib/notifications.css';
import * as S from './styles';

const Info = ({ propData, propNewData }) => {

  const history = useHistory();
  const { viewLoading, viewError, viewContent } = useContext(MediaManagerContext);

  const [objData, setData] = useState(propData);
  const [optCatalog, setCatalog] = useState([ propNewData ? { id:'undefined', title:'undefined' } : { id: objData.CATALOG.catId, title: objData.CATALOG.catName } ]);
  const [optCategory, setCategory] = useState([ propNewData ? { id:'undefined', title:'undefined' } : { id: objData.CATEGORY[0].catId, title: objData.CATEGORY[0].catName } ]);
  const [mount, setMount] = useState(false);
  // console.log(objData);

  const optStatus = [
    { id: 'Active', title: 'Active' },
    { id: 'Processing', title: 'Processing' },
    { id: 'Disabled', title: 'Disabled' },
    { id: 'Blocked', title: 'Blocked' },
  ];
  const optStatusSimple = [
    { id: 'Active', title: 'Active' },
    { id: 'Disabled', title: 'Disabled' },
  ];
  const optFeatured = [
    { id: 'Active', title: 'Active' },
    { id: 'Disabled', title: 'Disabled' },
  ];
  const optYear = [
    { id: '2022', title: '2022' },
    { id: '2021', title: '2021' },
    { id: '2020', title: '2020' },
    { id: '2019', title: '2019' },
    { id: '2018', title: '2018' },
    { id: '2017', title: '2017' },
    { id: '2016', title: '2016' },
    { id: '2015', title: '2015' },
    { id: '2014', title: '2014' },
    { id: '2013', title: '2013' },
    { id: '2012', title: '2012' },
    { id: '2011', title: '2011' },
    { id: '2010', title: '2010' },
    { id: '2009', title: '2009' },
    { id: '2008', title: '2008' },
    { id: '2007', title: '2007' },
    { id: '2006', title: '2006' },
    { id: '2005', title: '2005' },
    { id: '2004', title: '2004' },
    { id: '2003', title: '2003' },
    { id: '2002', title: '2002' },
    { id: '2001', title: '2001' },
    { id: '2000', title: '2000' },
    { id: '1999', title: '1999' },
    { id: '1998', title: '1998' },
    { id: '1997', title: '1997' },
    { id: '1996', title: '1996' },
    { id: '1995', title: '1995' },
    { id: '1994', title: '1994' },
    { id: '1993', title: '1993' },
    { id: '1992', title: '1992' },
    { id: '1991', title: '1991' },
    { id: '1990', title: '1990' },
    { id: '1989', title: '1989' },
    { id: '1988', title: '1988' },
    { id: '1987', title: '1987' },
    { id: '1986', title: '1986' },
    { id: '1985', title: '1985' },
    { id: '1984', title: '1984' },
    { id: '1983', title: '1983' },
    { id: '1982', title: '1982' },
    { id: '1981', title: '1981' },
    { id: '1980', title: '1980' },
    { id: '1979', title: '1979' },
    { id: '1978', title: '1978' },
    { id: '1977', title: '1977' },
    { id: '1976', title: '1976' },
    { id: '1975', title: '1975' },
    { id: '1974', title: '1974' },
    { id: '1973', title: '1973' },
    { id: '1972', title: '1972' },
    { id: '1971', title: '1971' },
    { id: '1970', title: '1970' },
    { id: '1969', title: '1969' },
    { id: '1968', title: '1968' },
    { id: '1967', title: '1967' },
    { id: '1966', title: '1966' },
    { id: '1965', title: '1965' },
    { id: '1964', title: '1964' },
    { id: '1963', title: '1963' },
    { id: '1962', title: '1962' },
    { id: '1961', title: '1961' },
    { id: '1960', title: '1960' },
    { id: '1959', title: '1959' },
    { id: '1958', title: '1958' },
    { id: '1957', title: '1957' },
    { id: '1956', title: '1956' },
    { id: '1955', title: '1955' },
    { id: '1954', title: '1954' },
    { id: '1953', title: '1953' },
    { id: '1952', title: '1952' },
    { id: '1951', title: '1951' },
    { id: '1950', title: '1950' },
  ];
  const optType = [
    { id: 'Movie', title: 'Movie' },
    { id: 'TV Show', title: 'TV Show' },
  ]; // kes-dev-prod
  const optMPAA = [
    { id: 'G', title: 'G' },
    { id: 'PG', title: 'PG' },
    { id: 'PG-13', title: 'PG-13' },
    { id: 'R', title: 'R' },
    { id: 'NC-17', title: 'NC-17' },
  ];
  const optExplicitLyrics = [
    { id: 'Not', title: 'Not' },
    { id: 'Yes', title: 'Yes' },
  ];
  const optSale = [
    { id: 'Not', title: 'Not' },
    { id: 'Yes', title: 'Yes' },
  ];
  const optSalePrice = [
    { id: '0.00', title: '0.00' },
    { id: '0.99', title: '0.99' },
    { id: '1.99', title: '1.99' },
    { id: '6.99', title: '6.99' },
    { id: '12.99', title: '12.99' },
    { id: '15.99', title: '15.99' },
    { id: '19.99', title: '19.99' },
  ];

  const auxFormatDataCatalog = (data) => {
    return { id: data.catId, title: data.catName };
  };
  const auxFormatDataCategory = (data) => {
    return { id: data.catId, title: data.catName };
  };

  useEffect(() => {
    async function loadData() {

      // kes-dev-tmp
      const lstPromises = [
        api('GET', `/catalog`, null),
        api('GET', `/category`, null),
      ];

      const resGetData = await Promise.all(lstPromises);

      setCatalog(resGetData[0].data.resData.map(auxFormatDataCatalog));
      setCategory(resGetData[1].data.resData.map(auxFormatDataCategory));
      setMount(true);

      viewContent();
    }
    try {
      loadData();
    } catch (error) {
      viewError();
    }
  }, []);

  const handleSubmit = async data => {
    try {
      if (handleValidate()) {

        if (propNewData) {
          viewLoading();
          console.log(`Data POST`, data);
          const resPostData = await api('POST', `/media`, data);
          console.log(resPostData);

          N.success('Successfully updated');

          setTimeout(() => {
            history.push(`/media/${resPostData.data.resData.medId}`);
            window.location.reload();
          }, 1500);
        } else {
          viewLoading();
          console.log(`Data PUT`, data);
          const resPutData = await api('PUT', `/media/${objData.medId}/info`, data);
          console.log(resPutData);

          N.success('Successfully updated');

          setTimeout(() => {
            // history.push('/');
            window.location.reload();
          }, 1500);
        }

      }

      function handleValidate() {
        let varControl = true;

        console.log(data);

        if (data._medStatus !== 'Active' && data._medStatus !== 'Processing' && data._medStatus !== 'Disabled' && data._medStatus !== 'Blocked') {
          varControl = false;
          N.error('Status', 'Check parameters');
        } else {
          if (propNewData || (objData.medStatus !== 1 && objData.medStatus !== 3)) {
            if (data._medStatus !== 'Active' && data._medStatus !== 'Disabled') {
              varControl = false;
              N.error('Status', 'Check parameters');
            }
          }
          switch (data._medStatus) {
            case 'Active':
              data.medStatus = 0;
              break;
            case 'Processing':
              data.medStatus = 1;
              break;
            case 'Disabled':
              data.medStatus = 2;
              break;
            case 'Blocked':
              data.medStatus = 3;
              break;
            default:
              varControl = false;
              N.error('Error Status', 'Check parameters');
              break;
          }
        }

        if (data.catId === '') {
          varControl = false;
          N.error('Catalog', 'Check parameters');
        }

        if (data.medTitle === '') {
          varControl = false;
          N.error('Title', 'Check parameters');
        }

        if (data.medType === '') {
          varControl = false;
          N.error('Type', 'Check parameters');
        }

        let lstCategoriesTemp = [];
        if (data.medCategory1 === '' || data.medCategory1 === ' ') {
          varControl = false;
          N.error('Category', 'Check parameters');
        } else {
          let tmpCategory = '';
          // 1
          tmpCategory = data.medCategory1;
          lstCategoriesTemp.push(tmpCategory);
          // 2
          if (data.medCategory2 !== '' && data.medCategory2 !== ' ') {
            tmpCategory = data.medCategory2;
            lstCategoriesTemp.push(tmpCategory);
          }
          // 3
          if (data.medCategory3 !== '' && data.medCategory3 !== ' ') {
            tmpCategory = data.medCategory3;
            lstCategoriesTemp.push(tmpCategory);
          }
        }
        data.medCategory = lstCategoriesTemp.filter(function(item, index) {
          return lstCategoriesTemp.indexOf(item) === index;
        });

        if (data.medDescription === '') {
          varControl = false;
          N.error('Description', 'Check parameters');
        }

        data.medYear = parseInt(data.medYear);

        if (data.medMPAA === '') {
          varControl = false;
          N.error('MPAA', 'Check parameters');
        }

        if (data._medFeaturedMain !== 'Active' && data._medFeaturedMain !== 'Disabled') {
          varControl = false;
          N.error('Featured Main', 'Check parameters');
        } else {
          switch (data._medFeaturedMain) {
            case 'Active':
              data.medFeaturedMain = 0;
              break;
            case 'Disabled':
              data.medFeaturedMain = 1;
              break;
            default:
              varControl = false;
              N.error('Featured Main', 'Check parameters');
              break;
          }
        }

        if (data._medFeatured !== 'Active' && data._medFeatured !== 'Disabled') {
          varControl = false;
          N.error('Featured', 'Check parameters');
        } else {
          switch (data._medFeatured) {
            case 'Active':
              data.medFeatured = 0;
              break;
            case 'Disabled':
              data.medFeatured = 1;
              break;
            default:
              varControl = false;
              N.error('Featured', 'Check parameters');
              break;
          }
        }

        return varControl;
      }

    } catch (error) {
      console.error(error);
      N.error('Error save');
      viewContent();
    }
  }

  if (mount) {
    return (
        <>
        <S.Form onSubmit={handleSubmit} initialData={objData} >
          <S.DivInput propW="25%">
            <small>Status</small>
            <S.Select
              name="_medStatus"
              options={(propNewData || (objData.medStatus !== 1 && objData.medStatus !== 3)) ? optStatusSimple : optStatus}
              disabled={objData.medStatus === 1 || objData.medStatus === 3}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Date Created</small>
            <S.Input name="_medDateCreated" disabled />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Date Updated</small>
            <S.Input name="_medDateUpdated" disabled />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Rating</small>
            <RatingView propValue={3.5} />
            {/* <S.Input name="medRating" disabled /> */}
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Catalog</small>
            <S.Select
              name="catId"
              options={optCatalog}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="75%">
            <small>Title</small>
            <S.Input name="medTitle" disabled={false} />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Type</small>
            <S.Select
              name="medType"
              options={optType}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Category 1</small>
            <S.Select
              name="medCategory1"
              options={optCategory}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Category 2</small>
            <S.Select
              name="medCategory2"
              options={optCategory}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Category 3</small>
            <S.Select
              name="medCategory3"
              options={optCategory}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="100%">
            <small>Description</small>
            <S.Input name="medDescription" disabled={false} />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Year</small>
            <S.Select
              name="medYear"
              options={optYear}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>MPAA</small>
            <S.Select
              name="medMPAA"
              options={optMPAA}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Featured Main</small>
            <S.Select
              name="_medFeaturedMain"
              options={optFeatured}
              disabled={false}
            />
          </S.DivInput>
          <S.DivInput propW="25%">
            <small>Featured</small>
            <S.Select
              name="_medFeatured"
              options={optFeatured}
              disabled={false}
            />
          </S.DivInput>
          <S.DivButton>
            <ButtonLoader propTitle="SAVE" propSpinner={false} />
          </S.DivButton>
        </S.Form>
        <NotificationContainer />
      </>
    );
  } else {
    return <></>
  }
};

Info.defaultProps = {
  propData: {},
  propNewData: false
};

Info.propTypes = {
  propData: PropTypes.object,
  propNewData: PropTypes.bool,
};


export default Info;
